import Store from '@app/store';

import Analytics from '@module/analytics';
import Router from '@module/router';

import StaticPage from '@component/panel/content';

let pageLoad = true;
let context;

const trackSnowplowEvent = (key) => {
  if (!key) {
    Analytics.trackSnowplowEvent({
      category: 'pro',
      action: 'click_upgrade_to_pro',
    });

    return;
  }

  if (key === 'WeTransfer_Signup_Free_Conversion-tiers') {
    Analytics.trackSnowplowEvent({
      category: 'pro',
      action: 'click_sign_up_for_free',
      label: 'tiers',
    });
    return;
  }

  let label = '';
  switch (key) {
    case 'WeTransfer_Get_Pro_Conversion-title':
      label = 'title';
      break;
    case 'WeTransfer_Get_Pro_Conversion-features':
      label = 'features';
      break;
    case 'WeTransfer_Get_Pro_Conversion-tiers':
      label = 'tiers';
      break;
  }
  Analytics.trackSnowplowEvent({
    category: 'pro',
    action: 'click_upgrade_to_pro',
    label,
  });
};

const trackGoogleAnalyticEvent = (key) => {
  if (!key) {
    return;
  }

  if (key === 'WeTransfer_Signup_Free_Conversion-tiers') {
    Analytics.trackGoogleEvent({
      category: 'pro-upgrade-button-click',
      action: 'Free account Create',
      label: 'free-account-button-pricing',
    });
    return;
  }

  let label = '';
  switch (key) {
    case 'WeTransfer_Get_Pro_Conversion-title':
      label = 'pro-upgrade-button-hero';
      break;
    case 'WeTransfer_Get_Pro_Conversion-features':
      label = 'pro-upgrade-button-content';
      break;
    case 'WeTransfer_Get_Pro_Conversion-tiers':
      label = 'pro-upgrade-button-pricing';
      break;
  }
  Analytics.trackGoogleEvent({
    category: 'pro-upgrade-button-click',
    action: 'Pro Upgrade',
    label,
  });
};

const contentElementClickHandler = (e) => {
  if (e.currentTarget && e.currentTarget.dataset.pixelTracker) {
    const pixelTrackerKey = e.currentTarget.dataset.pixelTracker;
    trackSnowplowEvent(pixelTrackerKey);
    trackGoogleAnalyticEvent(pixelTrackerKey);
  }
};

export const plusPage = (instance) => {
  const url = new URL(location.href);

  // We want to be updated with store updates
  instance.subscribeToStore = true;

  const { route } = Store.getState();

  if (route.query.coupon) {
    // Add pro tier
    if (!url.searchParams.get('tier')) {
      url.searchParams.append('tier', 'plus');
    }

    Router.navigateTo('/sign-up', true, {
      search: url.searchParams.toString(),
    });
    return;
  }

  // Get our DOM elements
  const pixelTrackerElements = instance.node.querySelectorAll(
    '[data-pixel-tracker]'
  );

  const signUpProButtons = instance.node.querySelectorAll(
    '.button.button--signup_pro'
  );

  const signUpFreeButton = instance.node.querySelectorAll(
    '.button.button--signup_free'
  );

  if (context !== route.context) {
    pageLoad = true;
  }
  context = route.context;

  const addButtonParamsAndListeners = (buttons, tier) => {
    buttons.forEach(function (button) {
      const buttonUrl = new URL(button.getAttribute('href'), location.origin);

      // force set plus/free tier
      buttonUrl.searchParams.set('tier', tier);

      // Add current search params to href
      new URL(location.href).searchParams.forEach((val, key) => {
        if (!buttonUrl.searchParams.get(key)) {
          buttonUrl.searchParams.append(key, val);
        }
      });

      // If there is no trk code already, and the user came from google, add a trk
      if (
        !buttonUrl.searchParams.get('trk') &&
        document.referrer.includes('google.com')
      ) {
        const trkCode =
          tier === 'plus'
            ? 'WT202006_directly_to_pro_page_from_google_to_pro'
            : 'WT202006_directly_to_pro_page_from_google_to_fa';
        buttonUrl.searchParams.append('trk', trkCode);
      }

      button.setAttribute(
        'href',
        `${buttonUrl.pathname}?${buttonUrl.searchParams.toString()}`
      );

      // Add listener
      button.addEventListener('click', contentElementClickHandler);
    });

    pixelTrackerElements.forEach((tracker) => {
      tracker.addEventListener('click', () => {
        Analytics.trackWithPixelOrSDK(tracker.dataset.pixelTracker);
      });
    });
  };

  // Only once during page load.
  if (pageLoad) {
    pageLoad = false;

    addButtonParamsAndListeners(signUpProButtons, 'plus');
    addButtonParamsAndListeners(signUpFreeButton, 'free');
  }

  // When we navigate away from the page, cleanup listeners
  instance.onCleanup = () => {
    signUpProButtons.forEach((button) => {
      button.removeEventListener('click', contentElementClickHandler);
    });

    pageLoad = true;

    pixelTrackerElements.forEach((tracker) => {
      tracker.removeEventListener('click', Analytics.trackWithPixelOrSDK);
    });
  };
};

StaticPage.configure('/pro', plusPage);
